import React, { useEffect, useState, useRef } from 'react';
import { preferencesPhrasesStorage } from '../../services/preferencesPhrasesStorage';
import PhrasesListItem from './PhrasesListItem';
import PreferencesListSelectBlock from './PreferencesListSelectBlock';
import { SMALL_PART_PHRASES_COUNT } from '../../constant';
import DeletePhrasePopup from './DeletePhrasePopup';
import PreferencesListSelectIsDefault from './PreferencesListSelectIsDefault';
import DeletePhraseIcon from './DeletePhraseIcon';

const getPhrasesLength = () => preferencesPhrasesStorage.getPhrases().length;

const PhrasesList = ({ skipInitialLoad = false }) => {
    const [phrasesListIsChanged, setPhrasesListIsChanged] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const ref = useRef();

    const changePhrases = (phraseId) => {
        if (phraseId) {
            preferencesPhrasesStorage.removePhrase(phraseId);
        }
        setPhrasesListIsChanged(prev => !prev);
    };

    const scrollPhrasesList = () => {
        if (ref.current) {
            const rect = ref.current.getBoundingClientRect();
            if(rect.top < window.innerHeight && !isLoading && getPhrasesLength() > 0) {
                setIsLoading(true);
                preferencesPhrasesStorage.loadNextPhrases(
                    preferencesPhrasesStorage.getPhrases()[getPhrasesLength() - 1].id,
                    SMALL_PART_PHRASES_COUNT,
                    () => setIsLoading(false),
                );
            }
        }
    };

    useEffect(() => {
        if (!skipInitialLoad) {
            preferencesPhrasesStorage.loadNextPhrases('', preferencesPhrasesStorage.pageSize, changePhrases);
        } else {
            changePhrases();
        }
        preferencesPhrasesStorage.registerFiltersChangingObserver(changePhrases);
        return () => {
            preferencesPhrasesStorage.unRegisterFiltersChangingObserver(changePhrases);
            preferencesPhrasesStorage.changeSelectedPhrasesList('', true);
        };
    }, [skipInitialLoad]);

    return (
        <>
            <DeletePhrasePopup notifyPhrasesList={changePhrases} />
            <ul className="preference__list" onScroll={scrollPhrasesList}>
                {preferencesPhrasesStorage.getPhrases().map((phrase, index) => (
                    <li key={phrase.id}
                        className="block__content preference__phrases-item"
                        ref={index === preferencesPhrasesStorage.getPhrases().length - 1 ? ref : null}>
                        <PhrasesListItem preferencePhraseId={phrase.id}/>
                    </li>
                ))}
            </ul>
            {preferencesPhrasesStorage.getSelectedList().length && phrasesListIsChanged !== null ?
                <PreferencesListSelectBlock itemsManager={preferencesPhrasesStorage}>
                    <PreferencesListSelectIsDefault phrasesListManager={preferencesPhrasesStorage} />
                    <DeletePhraseIcon />
                </PreferencesListSelectBlock>
                :
                null}
        </>
    );
};

export default PhrasesList;
